import React from "react";
import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import Dialog from '@material-ui/core/Dialog';
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import CustomInputAdorned from "../../components/CustomInput/CustomInputAdorned.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import DialogTitle from '@material-ui/core/DialogTitle';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from "../../components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { workspaceDomain } from '../../shared/devStatus';
import UserAdminGeneral from './UserAdminGeneral';
import UserAdminLinks from './UserAdminLinks';
import UserAdminIT from './UserAdminIT';
import UserAdminAccess from './UserAdminAccess';
import UserAdminModalNav from './UserAdminModalNav';
import UserAdminHistory from './UserAdminHistory';
import TextField from '@material-ui/core/TextField';
import { userData } from './UserData';
import { getGciEntries } from "../../store/actions/gci.js";
const clone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}
const simpleEmailValidate = (email) => { return /^\S+@\S+\.\S+$/.test(email); }
const removeDomain = (email) => {
    if (!email) return '';
    return email.substring(0, email.lastIndexOf("@"));
}
const addDomain = (email, domain) => {
    if (!email) return '';
    return `${email}@${domain}`;
}
const Errors = (props) => {
    const errors = props.errorMessage ? props.errorMessage.split('. ') : [];
    return (
        <div style={{ marginTop: 20 }}>
            {errors.map(e => {
                return <span className="error-pills" key={e}>{e}</span>
            })}
        </div>
    )
}

const Modal = (props) => {
    const u = props.userEdit;
    const illi_backend_data = u ? u.illi_backend_data : {};
    const [firstname, setFirstname] = useState(u ? u.name.givenName : '');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [suspended, setSuspended] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [customData, setCustomData] = useState(userData);
    const [currentTab, setCurrentTab] = useState('Basic Info');
    const [displayPassword, setDisplayPassword] = useState(null);
    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    useEffect(() => {
        props.getGciEntries();
        
        if (props.userEdit) {
            const user = JSON.parse(JSON.stringify(props.userEdit));
            console.log('loading user for edit', user)
            setEmail(user.primaryEmail);
            setFirstname(user.name.givenName);
            setLastname(user.name.familyName);
            if (illi_backend_data.phone) {
                setPhone(illi_backend_data.phone);
            }
            setSuspended(user.suspended);
            
            if (illi_backend_data.custom_data) {
                setCustomData(illi_backend_data.custom_data);
            } else {
                if (user.customSchemas) {
                    if (user.customSchemas.custom_fields_data) {
                        const newCustomData = clone(customData);
                        Object.keys(user.customSchemas.custom_fields_data).forEach(field => {
                            newCustomData[field] = user.customSchemas.custom_fields_data[field];
                        });
                        setCustomData(newCustomData);
                    }
                }
            }

            if (illi_backend_data.id) {
                const user_id = illi_backend_data.id;
                props.getEarnedCommissions({
                    user_id
                })
            }
        }
    }, []);

    useEffect(() => {
        let errors = [];

        if (props.action === 'Add' || props.changePassword) {
            if (!password1) errors.push('Password is required');
            if (!password2) errors.push('Re-enter Password is required');
            if (password1 && password2) {
                if (password1 === password2) {
                } else {
                    errors.push('Passwords must match');
                }
                if (password1.length < 8) {
                    errors.push('Passwords have a minimum 8 characters');
                }
            }
        }

        if (props.changePassword) {
            if (errors.length > 0) {
                setErrorMessage(errors.join('. '));
            } else {
                setErrorMessage('');
            }
            return;
        }

        if (!email) errors.push('Email is required');
        if (!firstname) errors.push('Firstname is required');
        if (!lastname) errors.push('Lastname is required');

        if (phone) {
            if (phone.length > 20) {
                errors.push('Phone no. must be less than 20 characters')
            }
        }

        if (email) {
            if (!simpleEmailValidate(email)) {
                errors.push('Valid email is required');
            }
            if (email.indexOf(workspaceDomain) === -1) {
                errors.push('Your email needs to end with @' + workspaceDomain);
            }
        }

        if (customData.is_illi_employee) {
            if (customData.is_illi_employee === 'Agent') {
                if (!customData.DRE) {
                    errors.push('DRE# is required for Associates');
                }
            }
        } else {
            errors.push('(User Information) Specify if user is an illi employee or agent');
        }

        if (customData.is_illi_employee !== 'Employee') {
            if (!customData.baseCommissionRate) {
                errors.push(`(User Information) Base Commission Rate is required`);
            }
        }

        // enter custom data errors
        if (!customData.lets_sign_it) {
            errors.push(`(User Information) Let's sign it is required`);
        }
        if (!customData.illi_university) {
            errors.push(`(User Information) illi University answer is required`);
        }

        if (errors.length > 0) {
            setErrorMessage(errors.join('. '));
        } else {
            setErrorMessage('');
        }

    }, [firstname, lastname, email, password1, password2, phone, customData]);

    const showPassword = (
        (props.action === 'Edit' && props.changePassword)
        ||
        (props.action === 'Add')
    ) ?
        true : false;

    const showBasicInfo = (
        (props.action === 'Edit' && !props.changePassword)
        ||
        (props.action === 'Add')
    ) ?
        true : false;

    const showNav = (props.action === 'Edit' && props.changePassword) ? false : true;

    const passwordGenerator = () => {
        const values = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$';
        const password = (length) => {
            return Array.from(crypto.getRandomValues(new Uint32Array(length))).map((x) => values[x % values.length]).join('')
        }
        const randNum = Math.random() * (11 - 8) + 8
        return password(12);
    }

    const username = firstname && lastname ? `${firstname} ${lastname}` : ``; 

    console.log('customData user', customData, props);

    return (
        <Dialog
            open={props.open}
            keepMounted
            onClose={props.close}
            maxWidth="md"
            fullWidth={true}
        >
            <DialogTitle>
                <div style={{ textAlign: 'center' }}>{props.action} User {username}</div>
            </DialogTitle>
            <form
                autoComplete="off"
                style={{ padding: 20 }}
                onSubmit={(e) => {
                    e.preventDefault();
                }}>
                <GridContainer>
                    {showNav && <GridItem xs={12} sm={12} md={12}>
                        <UserAdminModalNav
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                            showHistory={props.action === 'Edit' && illi_backend_data && illi_backend_data.id}
                        />
                    </GridItem>}
                </GridContainer>
                {currentTab === 'Basic Info' &&
                    <div>
                        {showBasicInfo &&
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="First Name"
                                        inputProps={{
                                            value: firstname,
                                            onChange: (e) => { setFirstname(e.target.value) }
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Last Name"
                                        inputProps={{
                                            value: lastname,
                                            onChange: (e) => { setLastname(e.target.value) }
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Address 1"
                                        inputProps={{
                                            value: customData.street1,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    street1: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="illi Direct Phone"
                                        inputProps={{
                                            value: phone,
                                            onChange: (e) => { setPhone(e.target.value) }
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Personal Phone"
                                        inputProps={{
                                            value: customData.personal_phone,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    personal_phone: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                    <CustomInputAdorned
                                        labelText="Email"
                                        adornmentText={`@${workspaceDomain}`}
                                        inputProps={{
                                            value: removeDomain(email, workspaceDomain),
                                            onChange: (e) => {
                                                if (props.action !== 'Edit') {
                                                    setEmail(addDomain(e.target.value, workspaceDomain));
                                                }
                                            },
                                            readOnly: props.action === 'Edit' ? true : false
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="Address 2"
                                        inputProps={{
                                            value: customData.street2,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    street2: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomInput
                                        labelText="City"
                                        inputProps={{
                                            value: customData.city,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    city: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomSelect
                                        label="State"
                                        options={[{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }]}
                                        indx="abbreviation"
                                        desc="name"
                                        default={customData.state}
                                        choose={(e) => {
                                            const newCustomData = {
                                                ...customData,
                                                state: e
                                            };
                                            setCustomData(newCustomData);
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomInput
                                        labelText="Zipcode"
                                        inputProps={{
                                            value: customData.zipcode,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    zipcode: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="Personal Email"
                                        inputProps={{
                                            value: customData.personal_email,
                                            onChange: (e) => {
                                                const newCustomData = {
                                                    ...customData,
                                                    personal_email: e.target.value
                                                };
                                                setCustomData(newCustomData);
                                            }
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>}
                        {showPassword &&
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="Password"
                                        inputProps={{
                                            value: password1,
                                            onChange: (e) => { setPassword1(e.target.value) },
                                            type: 'password'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomInput
                                        labelText="Re-enter Password"
                                        inputProps={{
                                            value: password2,
                                            onChange: (e) => { setPassword2(e.target.value) },
                                            type: 'password'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    {(props.action !== 'Add' ?
                                        !showPassword ? true : false
                                        : false) && <FormGroup row>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={suspended}
                                                        onChange={() => { setSuspended(!suspended) }}
                                                        color="primary"
                                                        disabled={props.userEdit.isAdmin ? true : false}
                                                    />
                                                }
                                                label="Suspend (Check to suspend, sync to deactivate portal account)"
                                            />
                                        </FormGroup>}
                                </GridItem>
                            </GridContainer>}
                    </div>}

                {currentTab === 'General' &&
                    <UserAdminGeneral
                        customData={customData}
                        setCustomData={setCustomData}
                        illi_backend_data={illi_backend_data}
                        userList={props.userList}
                        action={props.action}
                        gci_entries={props.gci_entries}
                        earned_commissions={props.earned_commissions}
                    />}

                {currentTab === 'Links' &&
                    <UserAdminLinks
                        customData={customData}
                        setCustomData={setCustomData}
                    />}

                {currentTab === 'IT' &&
                    <UserAdminIT
                        customData={customData}
                        setCustomData={setCustomData}
                        property_options={props.property_options}
                    />}

                {currentTab === 'Access' &&
                    <UserAdminAccess
                        customData={customData}
                        setCustomData={setCustomData}
                        groupList={props.groupList}
                    />}

                {currentTab === 'Notes' &&
                    <GridItem xs={12} sm={12} md={12}>
                        <div className='custom-textfield'>
                            <TextField
                                label='Notes'
                                multiline
                                rowsMax='10'
                                value={customData ? customData.notes : ''}
                                onChange={(e) => {
                                    if (customData.notes.length < 250) {
                                        const newCustomData = { ...customData, notes: e.target.value };
                                        setCustomData(newCustomData);
                                    }
                                }}
                                margin='normal'
                            />
                        </div>
                    </GridItem>}

                {currentTab === 'History' && illi_backend_data && illi_backend_data.id &&
                    <GridItem xs={12} sm={12} md={12}>
                        <UserAdminHistory userId={illi_backend_data.id} />
                    </GridItem>}


                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <hr />
                        {props.action === 'Add' && <Button
                            color="success"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                                if (!errorMessage) {
                                    props.createWorkspaceUser({
                                        firstname,
                                        lastname,
                                        phone,
                                        password1,
                                        password2,
                                        email,
                                        customData
                                    });
                                    props.close();
                                }
                            }}
                            disabled={errorMessage ? true : false}
                        >
                            ADD
                        </Button>}
                        {props.action === 'Edit' && <Button
                            color="primary"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                                console.log('props', props, illi_backend_data);
                                const userDetails = {
                                    firstname,
                                    lastname,
                                    email,
                                    phone,
                                    customData,
                                    id: illi_backend_data.id
                                };
                                if (props.userEdit) {
                                    if (props.userEdit.suspended === true) {
                                        if (suspended === false) {
                                            userDetails.suspended = false;
                                        }
                                    }
                                    if (props.userEdit.suspended === false) {
                                        if (suspended === true) {
                                            userDetails.suspended = true;
                                        }
                                    }
                                }
                                if (password1 && showPassword) userDetails.password = password1;
                                props.updateWorkspaceUser(userDetails);
                                props.close();
                            }}
                            disabled={errorMessage ? true : false}
                        >
                            UPDATE
                        </Button>}
                        <Button
                            color="white"
                            style={{ marginRight: 20 }}
                            onClick={() => {
                                props.close();
                            }}
                        >
                            CANCEL
                        </Button>
                        {props.action === "Add" &&
                            <Button
                                color="white"
                                style={{ marginRight: 20 }}
                                onClick={() => {
                                    const newSuggestedPass = passwordGenerator();
                                    
                                    setDisplayPassword(newSuggestedPass);
                                }}
                            >
                                Generate Password
                            </Button>
                        }
                        {displayPassword &&
                            <GridContainer>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomInput
                                        labelText="Password"
                                        inputProps={{
                                            value: displayPassword,
                                            type: 'text'
                                        }}
                                        fullWidth={false}
                                    />
                                </GridItem>
                                <ClickAwayListener onClickAway={handleTooltipClose}>
                                    <Tooltip
                                        PopperProps={{
                                            disablePortal: true,
                                        }}
                                        onClose={handleTooltipClose}
                                        open={open}
                                        disableFocusListener
                                        disableHoverListener
                                        disableTouchListener
                                        title="Password Copied to Clipboard"
                                    >
                                        <div style={{ cursor: "pointer", position: 'relative', top: '20px' }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(displayPassword).then(function () {
                                                    
                                                }, function (err) {
                                                    console.error('Async: Could not copy text: ', err);
                                                });
                                                handleTooltipOpen();
                                            }}>
                                            <i className="fas fa-clipboard-list font-22"></i>
                                        </div>
                                    </Tooltip>
                                </ClickAwayListener>
                                <Button
                                    color="white"
                                    style={{ marginLeft: 20, marginRight: 20 }}
                                    onClick={() => {
                                        setPassword1(displayPassword);
                                        setPassword2(displayPassword);
                                    }}
                                >
                                    Copy Passwords
                                </Button>
                            </GridContainer>
                        }
                        {errorMessage && <Errors
                            errorMessage={errorMessage}
                        />}
                    </GridItem>
                </GridContainer>
            </form>
        </Dialog>
    )
}

const mapStateToProps = (state) => {
	return {
        gci_entries: state.gci.entries,
        earned_commissions: state.gci.earned_commissions
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createRsHistory: (data) => {
            dispatch(actions.createRsHistory(data));
        },
        getGciEntries: () => {
            dispatch(actions.getGciEntries());
        },
        getEarnedCommissions: (userObj) => {
            dispatch(actions.getEarnedCommissions(userObj));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);